var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 15C30 17.9667 29.1203 20.8668 27.472 23.3336C25.8238 25.8003 23.4811 27.7229 20.7403 28.8582C17.9994 29.9935 14.9834 30.2906 12.0736 29.7118C9.16393 29.133 6.49119 27.7044 4.3934 25.6066C2.29561 23.5088 0.866999 20.8361 0.288221 17.9264C-0.290558 15.0166 0.00649254 12.0006 1.14181 9.25975C2.27712 6.51886 4.19971 4.17618 6.66645 2.52796C9.13318 0.879735 12.0333 -3.53778e-08 15 0L15 2.53073C12.5338 2.53073 10.123 3.26204 8.07245 4.63218C6.02189 6.00232 4.42367 7.94976 3.4799 10.2282C2.53613 12.5067 2.2892 15.0138 2.77033 17.4326C3.25146 19.8514 4.43904 22.0732 6.1829 23.8171C7.92676 25.561 10.1486 26.7485 12.5674 27.2297C14.9862 27.7108 17.4933 27.4639 19.7718 26.5201C22.0502 25.5763 23.9977 23.9781 25.3678 21.9276C26.738 19.877 27.4693 17.4662 27.4693 15H30Z",
    fill: "#BFBFBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.3ee4a928f3b43ca312e541f56289c920.svg";
export { ForwardRef as ReactComponent };